import {useState, useEffect, useContext} from "react"
//import { useLocation } from 'react-router-dom';
import {Tabs} from "./Tabs";
import TablaTramitacionExternaContainer from "./TablaTramitacionExternaContainer";
import TablaTramitacionPagosContainer from "./TablaTramitacionPagosContainer";
import TablaTramitacionProyectoContainer from "./TablaTramitacionProyectoContainer";

import { useLocalStorage } from "../hooks/useLocalStorage";

const TramitacionesComponent = ({arrayEditando, handleIsEditing}) => {
    const { setItem, removeItem } = useLocalStorage();

    //const location = useLocation();
    //console.log('Estado de navegación recibido:', location.state);
    //const [activeTab, setActiveTab] = useState(location.state?.activeTab || "tab2");

    // Mapeo de tabs
    const tabMap = {
        'pagos': 'tab2',
        'proyectos': 'tab3',
        'externa': 'tab1'
    };
    
    const getDefaultTab = () => {
        // Si hay un tabActivo en el estado de navegación, usarlo        
        // USAMOS DIECTAMENTE DESDE EL LOCALSTORAGE, sin location.state
        // Si no hay tabActivo, verificar si hay un tab en localStorage
        const savedTab = localStorage.getItem('lastActiveTab');
        return tabMap[savedTab] || 'tab1'; // Si no hay nada, ir al tab1
    };

    // Guardar el tab activo cuando cambie
    const handleTabChange = (tab) => {
        localStorage.setItem('lastActiveTab', tab.id === 'tab2' ? 'pagos' :
            tab.id === 'tab3' ? 'proyectos' : 'externa');
    };

    const items = [
        {
            id: "tab1",
            label: 'Tramitación Externa',
            content: '',
            form:  <TablaTramitacionExternaContainer /> 
        },
        {
            id: "tab2",
            label: 'Tramitación Pagos',
            content: '',
            form: <TablaTramitacionPagosContainer arrayEditando={arrayEditando}/> 
        },        
        {
            id: "tab3",
            label: 'Tramitación Proyectos',
            content: '',
            form: <TablaTramitacionProyectoContainer arrayEditando={arrayEditando}/> 
        },
    ];
    
    return (
        <Tabs 
            items={items} 
            defaultActiveTab={getDefaultTab()}
            onTabChange={handleTabChange}
        />
    );
};
//activeTab
export default TramitacionesComponent;
